export default __webpack_public_path__ + "static/media/primary.096055911d989f85e676d7777b856610.svg";